export default function calculateAngle(A, B, C) {
  // definate vectors
  const BA = [A.x - B.x, A.y - B.y];
  const BC = [C.x - B.x, C.y - B.y];

  // dot product
  const dotProduct = BA[0] * BC[0] + BA[1] * BC[1];

  // dimension of vectors
  const magnitudeBA = Math.hypot(BA[0], BA[1]);
  const magnitudeBC = Math.hypot(BC[0], BC[1]);

  // calc angles as radian
  const angleRad = Math.acos(dotProduct / (magnitudeBA * magnitudeBC));
  const angleDeg = Math.round(Number((angleRad * (180 / Math.PI)).toFixed(2)));

  return angleDeg;
}
